import { B2tableType } from '@/types'

// 初始化状态
const initState = {
  // 列表数据
  tableInfo: {
    list: [] as B2tableType[],
    total: 0
  }
}

// 定义 action 类型
type Props = {
  type: 'B2/getList'
  payload: { list: B2tableType[]; total: number }
}

// reducer
export default function Reducer(state = initState, action: Props) {
  switch (action.type) {
    // 获取列表数据
    case 'B2/getList':
      return { ...state, tableInfo: action.payload }

    default:
      return state
  }
}
